import * as type from 'app/actionTypes/category';

export function getCategoryDetails(filter = {}) {
    return {
        type: type.GET_SHIPPING_CATEGORY_REQUESTED,
        payload: filter,
    }
}
